import CommonLayout from 'components/CommonLayout';
import Body from 'containers/CookiesPage/Body';
import messages from 'containers/CookiesPage/messages';
import React from 'react';

const CookiesPage = () => {
  return <CommonLayout title={messages.title} content={<Body />} />;
};

export default CookiesPage;
